import { ActionIcon, Tooltip } from '@mantine/core';
import { IconDeviceDesktop, IconMoon, IconSun } from '@tabler/icons-react';
import type { ColorScheme } from '../lib/colorScheme';
import { useAppColorScheme } from '../lib/colorScheme';

const ICONS: Record<ColorScheme, React.ReactNode> = {
  system: <IconDeviceDesktop size={17} />,
  light: <IconSun size={17} />,
  dark: <IconMoon size={17} />,
};

const LABELS: Record<ColorScheme, string> = {
  system: 'Systemfarbe',
  light: 'Helles Design',
  dark: 'Dunkles Design',
};

const NEXT_LABEL: Record<ColorScheme, string> = {
  system: 'Zu hell wechseln',
  light: 'Zu dunkel wechseln',
  dark: 'Zu System wechseln',
};

interface ThemeToggleProps {
  size?: 'sm' | 'md' | 'lg';
}

export function ThemeToggle({ size = 'md' }: ThemeToggleProps) {
  const { colorScheme, toggleColorScheme } = useAppColorScheme();

  return (
    <Tooltip label={NEXT_LABEL[colorScheme]} withArrow>
      <ActionIcon
        variant="subtle"
        size={size}
        onClick={() => toggleColorScheme()}
        aria-label={LABELS[colorScheme]}
        className="contrast-icon-btn"
      >
        {ICONS[colorScheme]}
      </ActionIcon>
    </Tooltip>
  );
}
